import { Pipe, PipeTransform } from '@angular/core';
import { AuthenticationStateService } from '@quorum/authentication/services';
import { Employee } from '@quorum/models/xs-resource';
import { SystemControlStateService } from '@quorum/xsr-system-control/services';
import { filter, map, switchMap } from 'rxjs/operators';

@Pipe({
  name: 'unitOfMeasure',
})
export class UnitOfMeasurePipe implements PipeTransform {
  constructor(
    private authenticationStateService: AuthenticationStateService,
    private systemControlStateService: SystemControlStateService
  ) {}
  transform(value: string) {
    return this.authenticationStateService.selectAuthenticatedEmployee().pipe(
      filter((employee): employee is Employee => employee != null && employee.rooftopId != null),
      switchMap((employee) => {
        return this.systemControlStateService.getSystemControlValues(['CL_UNIT_OF_MEASURE'], employee.rooftopId);
      }),
      map((sysControls) => {
        if (parseInt(value) >= 0) {
          return value + (sysControls?.CL_UNIT_OF_MEASURE?.value == 'M' ? ' mi' : ' km');
        } else {
          return 'N/A';
        }
      })
    );
  }
}
